import { Box, Theme, Typography } from "@mui/material";
import CustomTable from "../../investorOverview/common/customTable";
import { MaxAllocationMFBody } from "./tableBodies";
import { MaxAllocationMFHeaders } from "./tableHeaders";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { GetPortfolioComplianceResponseBody } from "../../../redux-store/types/analytics";
import { RootStateType } from "../../../redux-store/reducers";
import { getPortfolioCompliance } from "../../../redux-store/actions/analytics";
import { NO_DATA_ERROR_MESSAGE } from "../../../utils/constant";

export default function MaxAllocationMFTable({
    clientCode,
    portfolioId
}: {
    clientCode: string;
    portfolioId: string;
}): JSX.Element {
    const dispatch = useDispatch();

    const [isLoading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<GetPortfolioComplianceResponseBody>({} as GetPortfolioComplianceResponseBody)

    const { iwappRmId = "" } = useSelector((state: RootStateType) => state.id);

    const fetchData = async (clientCode: string, portfolioId: string) => {
        try {
            setLoading(true)

            const payload = {
                rmId: `${iwappRmId}`,
                clientCode,
                portfolioId,
                assetGroup: null
            }

            const response = await (dispatch(getPortfolioCompliance(payload)) as unknown as Promise<GetPortfolioComplianceResponseBody>);

            setData(response)

        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData(clientCode, portfolioId)
    }, [])

    if (!isLoading && !data?.isSuccess) {
        return (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    position: "relative"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary,
                        textAlign: "center",
                        width: "100%"
                    })}
                >
                    {NO_DATA_ERROR_MESSAGE}
                </Typography>
            </Box>
        )
    }

    return (
        <Box sx={{ mt: '32px' }}>
            <CustomTable
                loadingRowsNum={5}
                isLoading={isLoading}
                tableBody={
                    <MaxAllocationMFBody
                        tableBodyData={data?.result ?? []}
                    />
                }
                tableData={data?.result ?? []}
                tableBodyLoaderRowCustomStyles={{
                    '& td:first-of-type': {
                        paddingLeft: "0px"
                    },
                }}
                tableHeaderData={MaxAllocationMFHeaders}
                tableHeadRowCustomStyles={{
                    '& th:first-of-type': {
                        paddingLeft: "0px",
                    }
                }}
                tableBodyCustomStyles={{
                    '& tr:last-child td': {
                        border: 0
                    }
                }}
                tableDataCount={(data?.result ?? []).length}
                isPaginationVisible={false}
            />
        </Box>
    )
}